import { render, staticRenderFns } from "./OversightDashboard.vue?vue&type=template&id=8e0452de&scoped=true&"
import script from "./OversightDashboard.vue?vue&type=script&lang=ts&"
export * from "./OversightDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0452de",
  null
  
)

export default component.exports